module.exports = __webpack_public_path__ + "img/research.0f4fc0fa.png";